import { LoaderIcon } from "react-hot-toast";
import styles from "./button.module.scss";
import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  label: string;
  loading?: boolean;
  handleClick?: () => void;
  type: "button" | "reset" | "submit";
  disabled?: boolean;
  design?:
    | "primary"
    | "secondary"
    | "tertiary"
    | "other"
    | "another"
    | "template-2"
    | "transparent";
  className?: string;
}

const Button: React.FC<ButtonProps> = ({
  children,
  type,
  label,
  handleClick,
  disabled,
  loading = false,
  design = "primary",
  className,
  ...rest
}) => {
  return (
    <button
      onClick={handleClick}
      aria-label={label}
      type={type}
      className={`${
        className
          ? className
          : design === "primary"
          ? styles["button__primary"]
          : design === "secondary"
          ? styles["button__secondary"]
          : design === "tertiary"
          ? styles["button__tertiary"]
          : design === "other"
          ? styles["button__other"]
          : design === "another"
          ? styles["button__another"]
          : design === "template-2"
          ? "w-max !text-white bg-inawo-blue-100 hover:bg-inawo-blue-100/90 transition-colors ease-in-out duration-300 p-4 rounded-[0.25rem]"
          : design === "transparent"
          ? styles["button__transparent"]
          : ""
      }`}
      disabled={disabled || loading}
      {...rest}
    >
      <span>{loading ? <LoaderIcon /> : children}</span>
    </button>
  );
};

export default Button;
